/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import styled from '@emotion/styled'
import React from 'react'
import { Icon, IconName } from '../../utils/Icon'
import { VStack } from './VStack'
import { Horizon } from '../map_facilities/Horizon'
import { CardSection, Heading } from './CardSection'

export type AccessProps = {
  address: string
  mapUrl?: string
  phoneNumber: string
  siteUrl: string
}

export const Access = ({
  address,
  mapUrl,
  phoneNumber,
  siteUrl,
}: AccessProps) => {
  return (
    <CardSection>
      <Heading
        style={{
          marginBottom: '25px',
        }}
      >
        アクセス
      </Heading>
      <VStack gap="20px">
        <AccessRow
          title="所在地"
          iconName="location_on"
          value={address}
          href={mapUrl}
          targetBlank
        />
        <AccessRow
          title="電話"
          iconName="phone"
          value={phoneNumber}
          href={`tel:${phoneNumber}`}
        />
        <AccessRow
          title="ウェブサイト"
          iconName="web"
          value={siteUrl}
          href={siteUrl}
          targetBlank
        />
      </VStack>
    </CardSection>
  )
}

type AccessRowProps = {
  title
  iconName: IconName
  value: string
  href?: string
  targetBlank?: boolean
}

const AccessRow = ({
  title,
  iconName,
  value,
  href,
  targetBlank,
}: AccessRowProps) => {
  return (
    <VStack gap="3px" css={accessRowStyle}>
      <Horizon columnGap="6px">
        <Icon
          iconName={iconName}
          style={{
            height: '14px',
            width: '14px',
          }}
        />
        <b>{title}</b>
      </Horizon>
      {href ? (
        <Link
          href={href}
          target={targetBlank ? '_blank' : ''}
          rel={targetBlank ? 'noopener' : ''}
          style={{
            overflow: 'hidden',
          }}
        >
          {value}
          {targetBlank && (
            <Icon
              iconName="blank"
              style={{
                height: '14px',
                width: '14px',
                marginLeft: '2px',
              }}
            />
          )}
        </Link>
      ) : (
        <span>{value}</span>
      )}
    </VStack>
  )
}

const Link = styled.a({
  overflow: 'hidden',
})

const accessRowStyle = css`
  font-size: 14px;
  line-height: 160%;
  & b {
    font-weight: bold;
    line-height: 150%;
  }
  & a {
    display: inline-block;
    text-decoration-line: underline;

    &:visited,
    &:link {
      color: inherit;
    }
  }
`
